import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
import clsx from 'clsx';

import styles from './VisuallyHidden.module.css';

export interface VisuallyHiddenProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
}

/**
 * Text for assistive technology only. Used by every component that carries
 * meaning in a fill or a glyph: the fill is the fast channel, this is the
 * channel that survives colour blindness and forced colours.
 */
export const VisuallyHidden = forwardRef<HTMLSpanElement, VisuallyHiddenProps>(
  function VisuallyHidden({ className, children, ...rest }, ref) {
    return (
      <span {...rest} ref={ref} className={clsx(styles.visuallyHidden, className)}>
        {children}
      </span>
    );
  },
);
